import { render, staticRenderFns } from "./activeitem.vue?vue&type=template&id=791a7c1e&scoped=true&"
import script from "./activeitem.vue?vue&type=script&lang=js&"
export * from "./activeitem.vue?vue&type=script&lang=js&"
import style0 from "./activeitem.vue?vue&type=style&index=0&id=791a7c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a7c1e",
  null
  
)

export default component.exports